import { QrCodeIcon } from '@heroicons/react/24/outline';

import { useTranslations } from '@northladder/i18n';

/**
 * -----------------------------------------------------------------------------
 * UI shown when the user navigates to the app without proper sessionId in the URL.
 * Shows them a message prompting them to re-scan the QR code.
 */
export function SessionNotFound() {
  const t = useTranslations('StartNewSession');

  return (
    <div className="flex min-h-[calc(100vh-15rem)] flex-col justify-center">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div
          className="
            shadow-xs bg-white px-4 py-8 dark:bg-gray-900/50
            sm:rounded-3xl sm:px-10
          "
        >
          <div className="mx-auto px-4 text-center sm:px-6 lg:px-8">
            <div className="mx-auto flex max-w-4xl flex-col items-center py-8">
              <QrCodeIcon
                aria-hidden="true"
                className="
                  bg-primary-50 text-primary-700 dark:text-primary-200 dark:bg-primary-500/10
                  mx-auto my-12  h-16 w-16 rounded-full p-4
                "
              />
              <h1
                className="
                  text-primary-700 dark:text-primary-200 mt-4 text-xl font-normal
                  tracking-tight sm:text-xl
                "
              >
                {t('title')}
              </h1>
              <p className="text-primary-900 my-8 max-w-xl font-light dark:text-gray-200">
                {t('subTitle')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
